import { useTranslation } from "react-i18next";
import { SkeletonBlock } from "@/interface/ShareWindow/Skeletons/SkeletonBlock";
import styles from "./SkeletonBlock.module.scss";

export const UserSkeleton = () => {
    const { t } = useTranslation();

    return (
        <>
            <p className={styles.title}>{t("share.accessSetup")}</p>

            <div className={styles.skeletonUser}>
                <SkeletonBlock width={35} height={35} />

                <div className={styles.nameSurname}>
                    <SkeletonBlock width={340} height={14} style={{ marginBottom: "6px" }} />
                    <SkeletonBlock width={340} height={14} />
                </div>

                <SkeletonBlock width={100} height={35} />
            </div>
        </>
    );
};
